module.exports = __webpack_public_path__ + "img/Impressive-QR-code-designs.b969e7cd.jpg";